import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export const FLIGHT = 'FLIGHT';
export const HOTELS = 'HOTELS';
export const AUTOS = 'AUTOS';
export const BUSES = 'BUSES';
export const BOOKING = 'BOOKING';
export const HOME = 'HOME';
export const USER_HISTORY = 'USER_HISTORY';
export const TERMS_CONDITIONS = 'TERMS_CONDITIONS';
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const RESPONSABLE_TOURISM = 'RESPONSABLE_TOURISM';
export const RIGHT_REPENTANCE = 'RIGHT_REPENTANCE';
export const TREATMENT_PERSONAL_DATA = 'TREATMENT_PERSONAL_DATA';
export const USER_ALERTS = 'USER_ALERTS';
export const PACKAGES = 'PACKAGES';
export const MARRIOTT = 'MARRIOTT';
export const BYHOURS = 'BYHOURS';
export const TOUR_AND_ACTIVITIES = 'TOUR_AND_ACTIVITIES';

export const ROUTE_ICON_AND_TITLES = {
  [FLIGHT]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.FLIGHTS',
    ICON: Icon.Flights,
  },
  [HOTELS]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.HOTELS',
    ICON: Icon.Hotels,
  },
  [BYHOURS]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.BYHOURS',
    ICON: Icon.ByHours,
  },
  [BUSES]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.BUSES',
    ICON: Icon.Buses,
  },
  [PACKAGES]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.PACKAGES',
    ICON: Icon.Packages,
  },
  [AUTOS]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.AUTOS',
    ICON: Icon.Autos,
  },
  [MARRIOTT]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.MARRIOTT',
    ICON: Icon.MarriottBonvoyFlat,
  },
  [TOUR_AND_ACTIVITIES]: {
    TITLE: 'HEADER_MODULE.HEADER_TABS.TOUR_AND_ACTIVITIES',
    ICON: Icon.CivitatisFlat,
  }
};
